export let EntityId = /*#__PURE__*/function (EntityId) {
  EntityId["SiteLevel"] = "siteLevel";
  EntityId["StaticPage"] = "staticPage";
  return EntityId;
}({});
export let SiteLevelRules = /*#__PURE__*/function (SiteLevelRules) {
  SiteLevelRules["SITE_LANGUAGE"] = "SITE_LANGUAGE";
  SiteLevelRules["VISUAL_INDICATORS"] = "VISUAL_INDICATORS";
  SiteLevelRules["SKIP_TO_MAIN_CONTENT"] = "SKIP_TO_MAIN_CONTENT";
  SiteLevelRules["DOM_ORDER"] = "DOM_ORDER";
  return SiteLevelRules;
}({});
export let StaticPageRules = /*#__PURE__*/function (StaticPageRules) {
  StaticPageRules["VALID_STATIC_PAGE_TITLE"] = "VALID_STATIC_PAGE_TITLE";
  StaticPageRules["HEADING_STRUCTURE"] = "HEADING_STRUCTURE";
  StaticPageRules["STATIC_ALT_TEXT"] = "STATIC_ALT_TEXT";
  StaticPageRules["COLOR_CONTRAST"] = "COLOR_CONTRAST";
  return StaticPageRules;
}({});
export let BiStatusTypes = /*#__PURE__*/function (BiStatusTypes) {
  BiStatusTypes["Completed"] = "completed";
  BiStatusTypes["Uncompleted"] = "uncompleted";
  BiStatusTypes["Loading"] = "loading";
  BiStatusTypes["HasIssues"] = "has issues";
  BiStatusTypes["NoIssues"] = "no issues";
  BiStatusTypes["NeedToScan"] = "need to scan";
  BiStatusTypes["CouldntCalcData"] = "couldn't calc data";
  BiStatusTypes["Error"] = "error";
  return BiStatusTypes;
}({});
export let BiFieldNames = /*#__PURE__*/function (BiFieldNames) {
  BiFieldNames["AltText"] = "alt-text";
  BiFieldNames["HeadingTag"] = "heading-tag";
  BiFieldNames["Checkbox"] = "checkbox";
  BiFieldNames["MediaAlternativesRadio"] = "media-alternatives-radio";
  return BiFieldNames;
}({});
export let BiCtaNames = /*#__PURE__*/function (BiCtaNames) {
  BiCtaNames["Refresh"] = "refresh";
  BiCtaNames["ReadArticle"] = "read-article";
  BiCtaNames["SeoAccessibility"] = "seo&a11y";
  BiCtaNames["HTMLTag"] = "html";
  BiCtaNames["SeoAccessibilityModal"] = "modal_seo&a11y";
  BiCtaNames["HTMLTagModal"] = "modal_html";
  BiCtaNames["MenuLearnMoreAboutTheWizard"] = "menu-learn-more-about-the-wizard";
  BiCtaNames["ScanButton"] = "scan-button";
  BiCtaNames["MenuScanAgain"] = "menu-scan-again";
  BiCtaNames["MenuShowAdvancedSettings"] = "menu-show-advanced-settings";
  BiCtaNames["MenuHideAdvancedSettings"] = "menu-hide-advanced-settings";
  BiCtaNames["CloseTheWizard"] = "close-the-wizard";
  BiCtaNames["LearnAboutAccessibility"] = "learn-about-accessibility";
  BiCtaNames["WelcomeScanSite"] = "welcome-scan-site";
  BiCtaNames["FooterScanAgain"] = "footer-scan-again";
  BiCtaNames["NavigateToTab"] = "navigate-to-tab";
  BiCtaNames["LearnMore"] = "learn-more";
  BiCtaNames["FooterAccessibilityTipsLink"] = "footer-accessibility-tips-link";
  BiCtaNames["ManualTask"] = "manual-task";
  BiCtaNames["GetMoreA11yTips"] = "get-more-a11y-tips";
  BiCtaNames["MoreActions"] = "more-actions";
  BiCtaNames["A11Checklist"] = "a11-checklist";
  BiCtaNames["AutoDomOrderInfo"] = "auto-dom-order-info";
  BiCtaNames["AutoDomOrderCheckbox"] = "dom-order-checkbox";
  BiCtaNames["GoToManualTasks"] = "go-to-manual-tasks";
  BiCtaNames["Apply"] = "apply";
  BiCtaNames["Cancel"] = "cancel";
  BiCtaNames["Edit"] = "edit";
  BiCtaNames["Save"] = "Save";
  BiCtaNames["Back"] = "back";
  BiCtaNames["BackToSiteView"] = "back-to-site-view";
  BiCtaNames["BackFromCrossPage"] = "back-from-cross-page";
  BiCtaNames["DropdownClick"] = "dropdown-click";
  BiCtaNames["DiscardChanges"] = "discard-changes";
  BiCtaNames["AddAltText"] = "add-alt-text";
  BiCtaNames["TryAgain"] = "try-again";
  BiCtaNames["ProceedWithout"] = "proceed-without";
  BiCtaNames["EnableAutoDomOrder"] = "enable-auto-dom-order";
  BiCtaNames["ColorContrast"] = "color-contrast";
  BiCtaNames["W3CStatementGenerator"] = "w3c-statement-generator";
  BiCtaNames["LearnAboutColorContrastRequirements"] = "learn-about-color-contrast-requirements";
  BiCtaNames["ForegroundOpenColorPicker"] = "foreground-open-color-picker";
  BiCtaNames["BackgroundOpenColorPicker"] = "background-open-color-picker";
  BiCtaNames["ForegroundOpenColorSlider"] = "foreground-open-color-slider";
  BiCtaNames["BackgroundOpenColorSlider"] = "background-open-color-slider";
  BiCtaNames["ForegroundColorRevert"] = "foreground-color-revert";
  BiCtaNames["BackgroundColorRevert"] = "background-color-revert";
  BiCtaNames["BackgroundColorCopy"] = "background-color-copy";
  BiCtaNames["ForegroundColorCopy"] = "foreground-color-copy";
  BiCtaNames["ColorContrastRatioInfo"] = "color-contrast-ratio-info";
  BiCtaNames["ForegroundColorPickerClose"] = "foreground-color-picker-close";
  BiCtaNames["BackgroundColorPickerClose"] = "background-color-picker-close";
  BiCtaNames["ForegroundColorPickerEdit"] = "foreground-color-picker-edit";
  BiCtaNames["BackgroundColorPickerEdit"] = "background-color-picker-edit";
  BiCtaNames["ForegroundColorPickerAdd"] = "foreground-color-picker-add";
  BiCtaNames["BackgroundColorPickerAdd"] = "background-color-picker-add";
  BiCtaNames["OpenDashboard"] = "open-dashboard";
  BiCtaNames["TopPaginationNext"] = "top-pagination-next";
  BiCtaNames["TopPaginationPrev"] = "top-pagination-prev";
  BiCtaNames["BottomPaginationNext"] = "bottom-pagination-next";
  BiCtaNames["BottomPaginationPrev"] = "bottom-pagination-prev";
  BiCtaNames["GetStarted"] = "get-started";
  BiCtaNames["Generate"] = "generate";
  BiCtaNames["StopGenerating"] = "stop-generating";
  BiCtaNames["ContinueGenerating"] = "continue-generating";
  BiCtaNames["ReviewNow"] = "review-now";
  BiCtaNames["X"] = "x";
  BiCtaNames["SortFirst"] = "sort-first";
  BiCtaNames["Upgrade"] = "upgrade";
  BiCtaNames["MinimizeImage"] = "minimize-image";
  BiCtaNames["EnlargeImage"] = "enlarge-image";
  BiCtaNames["ShowSettings"] = "show-settings";
  BiCtaNames["ShowAllPages"] = "show-all-pages";
  BiCtaNames["HideSettings"] = "hide-settings";
  BiCtaNames["ScanAllSite"] = "scan-all-site";
  BiCtaNames["ScanOnlyPage"] = "scan-only-page";
  BiCtaNames["SaveAndScan"] = "save-and-scan";
  BiCtaNames["OrganizeContent"] = "organize-content";
  BiCtaNames["ContinueScan"] = "continue-scan";
  BiCtaNames["ContrastChecker"] = "contrast-checker";
  BiCtaNames["ScanPages"] = "scan-pages";
  BiCtaNames["SkipScan"] = "skip-scan";
  BiCtaNames["MissingSavePermissionHelp"] = "missing-save-permission-help";
  BiCtaNames["CancelAndRevertChanges"] = "cancel-and-revert-changes";
  BiCtaNames["Continue"] = "continue";
  BiCtaNames["FixIssues"] = "fix-issues";
  BiCtaNames["ScanForIssues"] = "scan-for-issues";
  BiCtaNames["ReviewIssues"] = "review-issues";
  BiCtaNames["ScanAgain"] = "scan-again";
  BiCtaNames["NoIssuesButton"] = "no-issues-button";
  BiCtaNames["View"] = "view";
  BiCtaNames["FailedElementsContainer"] = "failed-elements-container";
  BiCtaNames["RescanSite"] = "rescan-site";
  return BiCtaNames;
}({});
export let BiScreenTypes = /*#__PURE__*/function (BiScreenTypes) {
  BiScreenTypes["WelcomeScreen"] = "welcome-screen";
  BiScreenTypes["ManualTasks"] = "manual-tasks";
  BiScreenTypes["DetectedIssues"] = "detected-issues";
  BiScreenTypes["ApplyFromTask"] = "apply-from-task";
  BiScreenTypes["DetectedIssuesMenu"] = "detected-issues-menu";
  BiScreenTypes["SiteInfo"] = "site-info";
  return BiScreenTypes;
}({});
export let BiNotificationTypes = /*#__PURE__*/function (BiNotificationTypes) {
  BiNotificationTypes["AutoDOMOrder"] = "auto-dom-order";
  BiNotificationTypes["ErrorMessageSecondaryLanguage"] = "error-message-secondary-language";
  BiNotificationTypes["ErrorMessageSecondaryBranch"] = "error-message-secondary-branch";
  BiNotificationTypes["TotalImagesLimit"] = "total-images-limit";
  BiNotificationTypes["altTextGeneratedResultsStatus"] = "Alt text generate results status";
  BiNotificationTypes["AiCanMakeMistakes"] = "ai-can-make-mistakes";
  BiNotificationTypes["ErrorMessageMissingSavePermission"] = "error-message-missing-save-permission";
  return BiNotificationTypes;
}({});
export let NotPremiumTooltipTypes = /*#__PURE__*/function (NotPremiumTooltipTypes) {
  NotPremiumTooltipTypes["Single"] = "alt_text_element_not_premium";
  NotPremiumTooltipTypes["Multiple"] = "alt_text_task_not_premium";
  return NotPremiumTooltipTypes;
}({});
export let generalToolTips = /*#__PURE__*/function (generalToolTips) {
  generalToolTips["rescanPage"] = "rescan-page";
  generalToolTips["verifyChanges"] = "verify-changes";
  return generalToolTips;
}({});
export let BiModalTypes = /*#__PURE__*/function (BiModalTypes) {
  BiModalTypes["UnableToAnalyzePages"] = "unable-to-analyze-pages";
  BiModalTypes["UnableToOrganizeDOMOrder"] = "unable-to-organize-dom-order";
  BiModalTypes["UnableToOrganizeDOMOrderPage"] = "unable-to-organize-dom-order-page";
  BiModalTypes["UnableToFetchDmData"] = "unable-to-fetch-dm-data";
  BiModalTypes["UnableToFetchVerticalsData"] = "unable-to-fetch-verticals-data";
  BiModalTypes["UnableToFetchTpaData"] = "unable-to-fetch-tpa-data";
  BiModalTypes["ProceedWithoutAutoDOM"] = "proceed-without-auto-dom";
  BiModalTypes["PreparingSiteForScan"] = "a11y-preparing-site-for-scan";
  BiModalTypes["ScanningForA11yIssues"] = "a11y-scanning-for-issues";
  BiModalTypes["UpdatingScanResults"] = "a11y-updating-scan-results";
  BiModalTypes["SaveBeforeLeaving"] = "save-before-leaving";
  BiModalTypes["CantSaveChanges"] = "cant-save-changes";
  BiModalTypes["GenerateWithAi"] = "generate-with-ai";
  BiModalTypes["ReviewRecentChanges"] = "review-recent-changes";
  BiModalTypes["GenerateWithAiError"] = "generate-with-ai-error";
  BiModalTypes["CantVerifyChanges"] = "cant-verify-changes";
  BiModalTypes["AdvancedSettings"] = "expose-dev-tools";
  BiModalTypes["UnableToAnalyzeSite"] = "unable-to-analyze-site";
  BiModalTypes["UnableToFetchRuleExecutionResults"] = "unable-to-fetch-rule-execution-results";
  BiModalTypes["ScanAllSiteVerification"] = "scan-all-site-verification";
  BiModalTypes["ScanItemTypeVerification"] = "scan-item-type-verification";
  BiModalTypes["SettingDomOrderForRTL"] = "setting DOM order for RTL";
  BiModalTypes["SettingDomOrderForLTR"] = "setting DOM order for LTR";
  BiModalTypes["SaveChangesBeforeScan"] = "save-changes-before-scan";
  BiModalTypes["ContinueFromWhereYouLeft"] = "continue from where you left";
  return BiModalTypes;
}({});
//# sourceMappingURL=types.js.map